<template>
  <div class="share-wrap">
      <div class="share-btn">
          <!-- <img class="share" src="@/assets/images/share.png" alt=""> -->
					<div>{{$t('share')}}</div>

              
           <div class="share-child">
                <!-- <div class="addthis_toolbox addthis_default_style addthis_32x32_style">
                    <a class="addthis_button_preferred_1"></a>
                    <a class="addthis_button_preferred_2"></a>
                    <a class="addthis_button_preferred_3"></a>
                    <a class="addthis_button_preferred_4"></a>
                    <a class="addthis_button_compact"></a>
                </div> -->
               <!-- <div class="shar-child-item twi" @click="goShare('twi')">
                  <img src="@/assets/images/Twitter.png" alt="">
              </div>

               <div class="shar-child-item face" @click="goShare('face')">
                  <img src="@/assets/images/facebook.png" alt="">
              </div> -->
               <div class="shar-child-item twi">
                   <ShareNetwork
											network="facebook"
											:url="shareUrl"
											:title="obj.name">
											<!-- <span>Facebook</span> -->
											<img src="@/assets/images/facebook.png" alt="">
									</ShareNetwork>
              </div>

               <div class="shar-child-item face">
                  <ShareNetwork
											network="twitter"
											:url="shareUrl"
											:title="obj.name"
											twitter-user="LindaOjo_">
											<!-- <span>Twitter</span> -->
											<img src="@/assets/images/Twitter.png" alt="">
									</ShareNetwork>
              </div>
              <div class="shar-child-item vk">
                  <ShareNetwork
											network="vk"
											:url="shareUrl"
											:title="obj.name">
											<!-- <span>VKontakte</span> -->
											<img src="@/assets/images/VKontakte.png" alt="">
									</ShareNetwork>
              </div>
							<div class="shar-child-item pin">
							    <ShareNetwork
											network="pinterest"
											:url="shareUrl"
											:title="obj.name">
											<!-- <span>pinterest</span> -->
											<img src="@/assets/images/pinterest.png" alt="">
									</ShareNetwork>
							</div>
          </div>
      </div>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/config/env.js";
import storage from "@/utils/storage";
export default {
    props: {
        obj: {}
    },
		data() {
			return {
				apiBaseUrl,
				shareUrl: ''
			}
		},
		mounted(){
			this.getShareUrl()
		},
    methods: {
			getShareUrl() {
				let data={
					client: 5,
					page: 2,
					type: 1,
					url: '/jump',
					params: {
						goods_id: this.obj.id
					}
				}
				let userToken = storage.get("userToken");
				if(userToken) {
					data.token = userToken
				}
				const _this = this
				this.$api.share(data).then(res => {
				  if (res.status) {
						let url = res.data
				    _this.shareUrl = _this.apiBaseUrl.slice(0, -1) +'/web'+ url
				  }else{
						_this.$msg(_this.$t('getUrlFailed'))
					}
				})
			}
      
        // goShare(val) {
        //     let url = this.$route
        //     if(val == 'twi') {
        //         let link = 'https://twitter.com/intent/tweet?text=' + this.obj.name +' &url=' + window.location.href
        //         window.open(link,'_blank')
        //     }
        // }
    }
}
</script>

<style lang="scss" scoped>
.share-wrap{
    // width: 100px;
    height: 47px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
   
}
.share-btn{
	display: flex;
	align-items: center;
	margin-left: 20px;
    // width: 30px;
    // height: 30px;
    // position: relative;
    // &:hover {
    //     .share-child{
    //         display: block !important;
    //     }
    // }
    .share{
        width: 30px;
        height: 30px;
         
    }
    .share-child{
        // width: max-content;
        // width: 110px;
        // width: 46px;
        // height: 50px;
        // box-shadow: 0 0 20px 4px rgb(154 161 177 / 15%), 0 4px 80px -8px rgb(36 40 47 / 25%), 0 4px 4px -2px rgb(91 94 105 / 15%);
        // background-color: #fff;
        // display: flex;
        // align-items: center;
        // padding: 5px 10px 0;
        // padding-bottom: 0;
				display: flex;
    }
		
		.sharing {
			display: flex;
			flex-direction: column;
		}

    .shar-child-item{
        width: 30px;
        height: 30px; 
        border-radius: 4px;
        // margin-right: 10px;
				margin-bottom: 5px;
				margin-left: 10px;
				
        img  {
            width: 100%;
            height: 100%;
        }
        &.twi{
            background: rgb(29, 161, 242);
           
        }     

        &.face{
            background: rgb(59, 89, 152);
           
        }  
				&.vk {
					 background: rgb(81, 129, 184);
				}
				&.pin {
					background: rgb(230, 0, 35);
				}
    }
}

</style>